module.exports = __webpack_public_path__ + "static/img/buttonImg.635479b.png";